import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService, ModalType, ProgramTilesComponent } from '@program-suite/ui';
import { Router } from '@angular/router';
import { LookupStore, ProgramTile } from '@program-suite/data-common';
import { SelectWholesalerModalComponent } from '../select-wholesaler-modal/select-wholesaler-modal.component';

@Component({
  selector: 'lib-start-quote',
  imports: [CommonModule, ProgramTilesComponent],
  templateUrl: './start-quote.component.html',
  styleUrl: './start-quote.component.scss',
})
export class StartQuoteComponent {
  lookupStore = inject(LookupStore);
  tenants = computed(() => this.lookupStore.tenants());

  constructor(
    private router: Router,
    private modalService: ModalService,
  ) {
    this.lookupStore.loadLookup('tenants');
  }

  handleTileSelect(tile: ProgramTile) {
    // In future tile will include a programRoutingUrl to navigate to
    const modalOptions = {
      modalType: ModalType.Medium,
      data: {
        tenants: this.tenants()
      }
    };

    this.modalService.open(SelectWholesalerModalComponent, modalOptions, (tenantId) => {
      if (tenantId) {
        this.router.navigate(['quote/new'], { queryParams: {tenantId} });
        return;
      }
    });
  }
}
